export const age = [
    {value: 1},

];

for(let i= 2; i<=33; i++){
    age.push({value: i},)
}